import { call, put, takeEvery } from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import PmnFunctionsService from '../service';
import {
  showPmnFunction,
  showPmnFunctionError,
  showPmnFunctions,
  showPmnFunctionsError,
} from '../actions';
import actions from '../constants';

export function* pmnFunctions({ category }) {
  const { response, error } = yield call(callAdapter, PmnFunctionsService.pmnFunctions());
  if (error) {
    yield put(showPmnFunctionsError(category, error));
  } else {
    yield put(showPmnFunctions(category, response.items));
  }
}

export function* pmnFunction({ category, code }) {
  const { response, error } = yield call(callAdapter, PmnFunctionsService.pmnFunction(code));
  if (error) {
    yield put(showPmnFunctionError(category, code, error));
  } else {
    yield put(showPmnFunction(category, code, response));
  }
}

export default function* pmnFunctionsApi() {
  yield takeEvery([actions.FETCH_PMN_FUNCTIONS, actions.REFRESH_PMN_FUNCTIONS], pmnFunctions);
  yield takeEvery(actions.FETCH_PMN_FUNCTION, pmnFunction);
}
